<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-volume-up', fontSet: 'fad'}"
	[headerText]="data.recorderMapping.name + (T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_TITLE | translate)"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<mat-tab-group [mat-stretch-tabs]="false" color="accent">
			<mat-tab label="{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG | translate }}">
				<div class="tabContent row">
					<!-- =============================================== VOG Input ========================================= -->
					<div class="col-3">
						<sim-admin-settings-scroll-entries-con
							[getScrollEntryText]="getInputChannelName.bind(this)"
							(removeEntryEmitter)="removeChannel($event, data.recorderMapping.vogInputChannelIds)"
							[scrollEntries]="data.recorderMapping.vogInputChannelIds"
							[scrollContainerHeightInPX]="200"
						>
							<mat-form-field color="accent" style="width: 100%">
								<mat-label>{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_VOG | translate }}</mat-label>
								<mat-select
									(ngModelChange)="addChannel($event, data.recorderMapping.vogInputChannelIds)"
									[(ngModel)]="vogInputChannelId"
								>
									<mat-option [value]="null">{{
										T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_OPTION_VOG | translate
									}}</mat-option>
									@for (channel of filterVogInputChannels(); track channel.id) {
										<mat-option [value]="channel.id">
											{{ channel.displayAdminText }}
										</mat-option>
									}
								</mat-select>
							</mat-form-field>
						</sim-admin-settings-scroll-entries-con>
					</div>
					<!-- =============================================== VOP Input ========================================= -->
					<div class="col-3">
						<sim-admin-settings-scroll-entries-con
							[getScrollEntryText]="getInputChannelName.bind(this)"
							(removeEntryEmitter)="removeChannel($event, data.recorderMapping.vopInputChannelIds)"
							[scrollEntries]="data.recorderMapping.vopInputChannelIds"
							[scrollContainerHeightInPX]="200"
						>
							<mat-form-field color="accent" style="width: 100%">
								<mat-label>{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_VOP | translate }}</mat-label>
								<mat-select
									(ngModelChange)="addChannel($event, data.recorderMapping.vopInputChannelIds)"
									[(ngModel)]="vopInputChannelId"
									style="width: 100%"
								>
									<mat-option [value]="null">{{
										T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_OPTION_VOP | translate
									}}</mat-option>
									@for (channel of filterVopInputChannels(); track channel.id) {
										<mat-option [value]="channel.id">
											{{ channel.displayAdminText }}
										</mat-option>
									}
								</mat-select>
							</mat-form-field>
						</sim-admin-settings-scroll-entries-con>
					</div>
					<!-- =============================================== VTT Input ========================================= -->
					<div class="col-3">
						<sim-admin-settings-scroll-entries-con
							[getScrollEntryText]="getInputChannelName.bind(this)"
							(removeEntryEmitter)="removeChannel($event, data.recorderMapping.vttInputChannelIds)"
							[scrollEntries]="data.recorderMapping.vttInputChannelIds"
							[scrollContainerHeightInPX]="200"
						>
							<mat-form-field color="accent" style="width: 100%">
								<mat-label>{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_VTT | translate }}</mat-label>
								<mat-select
									(ngModelChange)="addChannel($event, data.recorderMapping.vttInputChannelIds)"
									[(ngModel)]="vttInputChannelId"
									style="width: 100%"
								>
									<mat-option [value]="null">{{
										T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_OPTION_VTT | translate
									}}</mat-option>
									@for (channel of filterVttInputChannels(); track channel.id) {
										<mat-option [value]="channel.id">
											{{ channel.displayAdminText }}
										</mat-option>
									}
								</mat-select>
							</mat-form-field>
						</sim-admin-settings-scroll-entries-con>
					</div>
					<!-- ============================================= Phone Input ========================================= -->
					<div class="col-3">
						<sim-admin-settings-scroll-entries-con
							[getScrollEntryText]="getPhoneInputChannelName.bind(this)"
							(removeEntryEmitter)="removeChannel($event, data.recorderMapping.phoneInputChannelIds)"
							[scrollEntries]="data.recorderMapping.phoneInputChannelIds"
							[scrollContainerHeightInPX]="200"
						>
							<mat-form-field color="accent" style="width: 100%">
								<mat-label>
									{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_TABLE_HEADER_PHONE | translate }}
								</mat-label>
								<mat-select
									(ngModelChange)="addPhoneInputChannel($event, data.recorderMapping.phoneInputChannelIds)"
									[(ngModel)]="phoneInputChannelId"
									style="width: 100%"
								>
									<mat-option [value]="null">
										{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_NO_PHONE_INPUT_CHANNEL | translate }}
									</mat-option>
									@for (channel of filterPhoneInputChannels(); track channel.id) {
										<mat-option [value]="channel.id">
											{{ channel.displayAdminText }}
										</mat-option>
									}
								</mat-select>
								@if (data.recorderMapping.phoneInputChannelIds.length === 1) {
									<mat-hint>
										{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_TABLE_DATA | translate }}
									</mat-hint>
								}
							</mat-form-field>
						</sim-admin-settings-scroll-entries-con>
					</div>
					<!-- ============================================== Flying Mics ======================================== -->
					<div class="col-3">
						<sim-admin-settings-scroll-entries-con
							[getScrollEntryText]="getInputChannelName.bind(this)"
							(removeEntryEmitter)="removeChannel($event, data.recorderMapping.flyingInputchannelIds)"
							[scrollEntries]="data.recorderMapping.flyingInputchannelIds"
							[scrollContainerHeightInPX]="200"
						>
							<mat-form-field color="accent" style="width: 100%">
								<mat-label>
									{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_FLYING_MICS | translate }}
								</mat-label>
								<mat-select
									(ngModelChange)="addChannel($event, data.recorderMapping.flyingInputchannelIds)"
									[(ngModel)]="flyingInputChannelId"
									style="width: 100%"
								>
									<mat-option [value]="null">
										{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_OPTION_FLYING | translate }}
									</mat-option>
									@for (channel of filterFlyingInputChannels(); track channel.id) {
										<mat-option [value]="channel.id">
											{{ channel.displayAdminText }}
										</mat-option>
									}
								</mat-select>
							</mat-form-field>
						</sim-admin-settings-scroll-entries-con>
					</div>
					<!-- ============================================== A2R/Vog Network Input ======================================== -->
					<div class="col-3">
						<sim-admin-settings-scroll-entries-con
							[getScrollEntryText]="getNetworkChannelName.bind(this)"
							(removeEntryEmitter)="removeChannel($event, data.recorderMapping.vogNetworkAudioInputChannelIds)"
							[scrollEntries]="data.recorderMapping.vogNetworkAudioInputChannelIds"
							[scrollContainerHeightInPX]="200"
						>
							<mat-form-field color="accent" style="width: 100%">
								<mat-label>
									{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_TABLE_HEADER_VOG_NETWORK | translate }}
								</mat-label>
								<mat-select
									(ngModelChange)="addChannel($event, data.recorderMapping.vogNetworkAudioInputChannelIds)"
									[(ngModel)]="vogNetworkInputChannelId"
									style="width: 100%"
								>
									<mat-option [value]="null">
										{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_OPTION_NETWORK_VOG | translate }}
									</mat-option>
									@for (channel of filterVogNetworkInputChannels(); track channel.id) {
										<mat-option [value]="channel.id">
											{{ channel.displayAdminText }}
										</mat-option>
									}
								</mat-select>
							</mat-form-field>
						</sim-admin-settings-scroll-entries-con>
					</div>
					<!-- ============================================== AoP/Vop Network Input ======================================== -->
					<div class="col-3">
						<sim-admin-settings-scroll-entries-con
							[getScrollEntryText]="getNetworkChannelName.bind(this)"
							(removeEntryEmitter)="removeChannel($event, data.recorderMapping.vopNetworkAudioInputChannelIds)"
							[scrollEntries]="data.recorderMapping.vopNetworkAudioInputChannelIds"
							[scrollContainerHeightInPX]="200"
						>
							<mat-form-field color="accent" style="width: 100%">
								<mat-label>
									{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_TABLE_HEADER_VOP_NETWORK | translate }}
								</mat-label>
								<mat-select
									(ngModelChange)="addChannel($event, data.recorderMapping.vopNetworkAudioInputChannelIds)"
									[(ngModel)]="vopNetworkInputChannelId"
									style="width: 100%"
								>
									<mat-option [value]="null">
										{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_OPTION_NETWORK_VOP | translate }}
									</mat-option>
									@for (channel of filterVopNetworkInputChannels(); track channel.id) {
										<mat-option [value]="channel.id">
											{{ channel.displayAdminText }}
										</mat-option>
									}
								</mat-select>
							</mat-form-field>
						</sim-admin-settings-scroll-entries-con>
					</div>
					<!-- ============================================== A2P/Vtt Network Input ======================================== -->
					<div class="col-3">
						<sim-admin-settings-scroll-entries-con
							[getScrollEntryText]="getNetworkChannelName.bind(this)"
							(removeEntryEmitter)="removeChannel($event, data.recorderMapping.vttNetworkAudioInputChannelIds)"
							[scrollEntries]="data.recorderMapping.vttNetworkAudioInputChannelIds"
							[scrollContainerHeightInPX]="200"
						>
							<mat-form-field color="accent" style="width: 100%">
								<mat-label>
									{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_TABLE_HEADER_VTT_NETWORK | translate }}
								</mat-label>
								<mat-select
									(ngModelChange)="addChannel($event, data.recorderMapping.vttNetworkAudioInputChannelIds)"
									[(ngModel)]="vttNetworkInputChannelId"
									style="width: 100%"
								>
									<mat-option [value]="null">
										{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_TABLE_HEADER_VTT_NETWORK | translate }}
									</mat-option>
									@for (channel of filterVttNetworkInputChannels(); track channel.id) {
										<mat-option [value]="channel.id">
											{{ channel.displayAdminText }}
										</mat-option>
									}
								</mat-select>
							</mat-form-field>
						</sim-admin-settings-scroll-entries-con>
					</div>
				</div>
			</mat-tab>

			<mat-tab label="{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_OUTPUTS | translate }}">
				<div class="tabContent row">
					<!-- =============================================== Direct Out ======================================== -->
					<div class="col-lg-4 col-md-4 col-sm-4">
						<mat-form-field color="accent" style="width: 100%">
							<mat-label>
								{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_TABLE_HEADER_DIRECT_OUT | translate }}
							</mat-label>
							<mat-select [formControl]="directOutputChannelIdFC" style="width: 100%">
								<mat-option [value]="null">{{
									T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_OPTION_DIRECT_OUT | translate
								}}</mat-option>
								@for (channel of availableOutputChannels; track channel.id) {
									<mat-option [value]="channel.id">
										{{ channel.displayAdminText }}
									</mat-option>
								}
							</mat-select>
							@if (data.recorderMapping.audioOutputChannelId) {
								<mat-hint>
									{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_TABLE_DATA_MESSAGE | translate }}
								</mat-hint>
							}
						</mat-form-field>
					</div>

					<!-- =============================================== Websocket Out ======================================== -->
					<div class="col-lg-4 col-md-4 col-sm-4">
						<mat-form-field color="accent" style="width: 100%">
							<mat-label>
								{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_TABLE_HEADER_WEBSOCKET_OUT | translate }}
							</mat-label>
							<mat-select [formControl]="websocketOutputChannelIdFC" style="width: 100%">
								<mat-option [value]="null">{{
									T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_OPTION_WEBSOCKET_OUT | translate
								}}</mat-option>
								@for (channel of availableWebsocketOutputChannels; track channel.id) {
									<mat-option [value]="channel.id">
										{{ channel.displayAdminText }}
									</mat-option>
								}
							</mat-select>
							@if (data.recorderMapping.websocketAudioOutputChannelId) {
								<mat-hint>
									{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_TABLE_DATA_MESSAGE | translate }}
								</mat-hint>
							}
						</mat-form-field>
					</div>

					<!-- =============================================== VOP Output ======================================== -->
					<div class="col-lg-4 col-md-4 col-sm-4">
						<sim-admin-settings-scroll-entries-con
							[getScrollEntryText]="getOutputChannelName.bind(this)"
							(removeEntryEmitter)="removeChannel($event, data.recorderMapping.vopOutputChannelIds)"
							[scrollEntries]="data.recorderMapping.vopOutputChannelIds"
							[scrollContainerHeightInPX]="200"
						>
							<mat-form-field color="accent" style="width: 100%">
								<mat-label>
									{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_TABLE_HEADER_VOP_OUT | translate }}
								</mat-label>
								<mat-select
									(ngModelChange)="addChannel($event, data.recorderMapping.vopOutputChannelIds)"
									[(ngModel)]="vopOutputChannelId"
									style="width: 100%"
								>
									<mat-option [value]="null">
										{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_OPTION_NO_AUDIO_OUTPUT | translate }}
									</mat-option>
									@for (channel of filterVopOutputChannels(); track channel.id) {
										<mat-option [value]="channel.id">
											{{ channel.displayAdminText }}
										</mat-option>
									}
								</mat-select>
							</mat-form-field>
						</sim-admin-settings-scroll-entries-con>
					</div>
					<!-- =============================================== VTT Output ====================================== -->
					<div class="col-lg-4 col-md-4 col-sm-4">
						<sim-admin-settings-scroll-entries-con
							[getScrollEntryText]="getOutputChannelName.bind(this)"
							(removeEntryEmitter)="removeChannel($event, data.recorderMapping.vttOutputChannelIds)"
							[scrollEntries]="data.recorderMapping.vttOutputChannelIds"
							[scrollContainerHeightInPX]="200"
						>
							<mat-form-field color="accent" style="width: 100%">
								<mat-label>
									{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_TABLE_HEADER_VTT_OUT | translate }}
								</mat-label>
								<mat-select
									(ngModelChange)="addChannel($event, data.recorderMapping.vttOutputChannelIds)"
									[(ngModel)]="vttOutputChannelId"
									style="width: 100%"
								>
									<mat-option [value]="null">
										{{ T.RECORDER_AUDIO_CHANNEL_SELECTION_DIALOG_OPTION_NO_AUDIO_OUTPUT_VTT | translate }}
									</mat-option>
									@for (channel of filterVttOutputChannels(); track channel.id) {
										<mat-option [value]="channel.id">
											{{ channel.displayAdminText }}
										</mat-option>
									}
								</mat-select>
							</mat-form-field>
						</sim-admin-settings-scroll-entries-con>
					</div>
				</div>
			</mat-tab>
		</mat-tab-group>
	</ng-container>
	<ng-container actions>
		<sim-button
			(onClick)="saveRecorderMapping()"
			[color]="'accent'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.BUTTON_OK"
		/>
	</ng-container>
</sim-basic-material-dialog>
